import { autoinject } from 'aurelia-framework';
import { QueryFilter } from 'lib/tables/DataFilter';
import { RopeTypeService, CheckDuplicateRopeTypeService } from 'models';
import { AuthHttpClient } from 'services/auth-http-client';
import { BaseApiService } from 'services/base-api-service';

@autoinject
export class RopeTypeServiceService extends BaseApiService<RopeTypeService> {
  constructor(httpClient: AuthHttpClient) {
    super(httpClient, RopeTypeService);
  }

  public getRopeTypeServiceList(filters: QueryFilter) {
    return this.httpClient.execWithResponseMeta<any[]>(`${RopeTypeService.ApiUrl}/list${filters.asQueryString}`, {
      method: 'GET',
    });
  }

  public async checkDuplicate(data: CheckDuplicateRopeTypeService) {
    return await this.httpClient.exec<{ IsDuplicate: boolean }>(`${RopeTypeService.ApiUrl}/checkDuplicate`, {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }
}
